import CalendarioGestionForm from "./CalendarioGestionForm";
import { postData } from "../../Utils/Http/api";

const mensajeAlta = (res) => {
  const creadas = res?.value?.creadas ?? 0;
  const yaExistian = res?.value?.yaExistian ?? 0;
  const texto = creadas === 1 ? "Se agregó 1 día al calendario" : `Se agregaron ${creadas} días al calendario`;
  return yaExistian > 0 ? `${texto} (${yaExistian} ${yaExistian === 1 ? "ya estaba cargado" : "ya estaban cargados"}).` : `${texto}.`;
};

const CalendarioGestionAdd = () => (
  <CalendarioGestionForm
    modo="alta"
    titulo="Agregar al Calendario de Gestores"
    descripcion="Elegí un gestor, el organismo que le toca y los días de la semana. Si ese día le tocan dos organismos, agregá cada uno por separado."
    valoresIniciales={{ idUsuario: null, idOrganismo: null, dias: [] }}
    onGuardar={(datos) => postData("/CalendarioGestionAlta", datos)}
    mensajeExito={mensajeAlta}
  />
);

export default CalendarioGestionAdd;
